const PREVIEW_PLACEHOLDERS: Record<string, string> = {
  '{{nombre_comprador}}': 'Socio Comprador Ejemplo',
  '{{nombre_vendedor}}': 'Socio Vendedor Ejemplo',
  '{{dni_comprador}}': '12345678-A',
  '{{dni_vendedor}}': '87654321-B',
  '{{num_acciones}}': '100',
  '{{clase_acciones}}': 'Clase A',
  '{{precio_accion}}': '50,00',
  '{{precio_total}}': '5.000,00',
  '{{fecha}}': '26 de marzo de 2026',
  '{{hora}}': '10:30',
  '{{referencia_operacion}}': '#TRX-2026-000001',
  '{{nombre_sociedad}}': 'Sociedad Ejemplo S.A.',
  '{{cif_sociedad}}': 'B12345678',
};

export const applyEquityMarketContractPreviewPlaceholders = (text: string) =>
  Object.entries(PREVIEW_PLACEHOLDERS).reduce(
    (acc, [token, value]) => acc.split(token).join(value),
    text
  );
